import { Route, Routes } from "react-router-dom";
import {
  Dashboard,
  LoginPage,
  PricesPage,
  RegisterPage,
  UsersPage,
  MarginsPage,
  OrdersPage,
  ReportsPage,
  TasksPage,
} from "./pages";
import PriceDetailsPage from "./pages/Prices/PriceDetailsPage";
import { Suspense } from "react";
import { ProtectedRoute } from "utils";
import { ROUTE_ENUM } from "./enums";

const RoutesComponent: React.FC = () => {
  return (
    <Suspense fallback={"..."}>
      <Routes>
        <Route path={"/"} element={<LoginPage />} />

        <Route
          path={ROUTE_ENUM.DASHBOARD}
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        >
          <Route
            path="prices"
            element={
              <ProtectedRoute>
                <PricesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="prices/:id"
            element={
              <ProtectedRoute>
                <PriceDetailsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="orders"
            element={
              <ProtectedRoute>
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="reports"
            element={
              <ProtectedRoute>
                <ReportsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="tasks"
            element={
              <ProtectedRoute>
                <TasksPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="users"
            element={
              <ProtectedRoute>
                <UsersPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="margins"
            element={
              <ProtectedRoute>
                <MarginsPage />
              </ProtectedRoute>
            }
          />
        </Route>
        <Route path={ROUTE_ENUM.REGISTER} element={<RegisterPage />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesComponent;
